import React from 'react';
import { config } from '../data/config';
import ContentCard from '../components/content-card';
import HomeLayout from '../components/layout/home-layout';
import { Link } from 'gatsby';
import GoldenEyeCareHero from '../components/layout/hero';
import GoldenEyeCareLayout from '../components/layout/layout';

// import './index.scss';

const ActivityPage = () => {
    return (
        <GoldenEyeCareLayout activePage="activity">
            <section className="section-links">
                <GoldenEyeCareHero />
                <div className="divider">
                </div>
                <div className="container" style={{ padding: '50px', textAlign: 'center'}}>
                    <h1>Coming Soon</h1>
                </div>
            </section>
        </GoldenEyeCareLayout>
    );
};

export default ActivityPage;
